export default class Order {
  
  constructor(attr) {
    this.id = null
    this.number = null
    this.scheduledPickupAt = null
    this.archived = false
    this.store = null
    this.status = null
    this.trackernumber = null
    this.pagernumber = null
    
    Object.assign(this, attr)
  }
  update(attr) {
    Object.assign(this, attr)
  }

  isStatusInBox() {
    return this.status && this.status.indexOf("in_box_") == 0
  }

  static get validStatus() {
    return [
      {
        "name": "Future order",
        "code": "backlog"
      },
      {
        "name": "New Order",
        "code": "new"
      },
      {
        "name": "In Production",
        "code": "in_production"
      },
      {
        "name": "Box 1",
        "code": "in_box_1"
      },
      {
        "name": "Box 2",
        "code": "in_box_2"
      },
      {
        "name": "Box 3",
        "code": "in_box_3"
      },
      {
        "name": "Box 4",
        "code": "in_box_4"
      },
      {
        "name": "Box 5",
        "code": "in_box_5"
      },
      {
        "name": "Box 6",
        "code": "in_box_6"
      },
      {
        "name": "Done",
        "code": "done"
      }
    ].map((status) => status.code)
  }
}